<template>
  <div class="el-tabs el-tabs--top el-tabs--border-card card">
    <div class="el-tabs__header is-top" v-if="warehouses.length > 1">
      <div class="el-tabs__nav-wrap is-top">
        <div class="el-tabs__nav-scroll">
          <div role="tablist" class="el-tabs__nav is-top is-stretch" style="transform: translateX(0px);">
            <div class="el-tabs__item is-top" :class="rotationType === 'rotation' ? 'is-active' : ''"
              @click="rotationType = 'rotation'"
            >
              Lagerbewegung
            </div>
            <div class="el-tabs__item is-top" :class="rotationType === 'instance' ? 'is-active' : ''"
              @click="rotationType = 'instance'"
            >
              Info
            </div>
            <div class="el-tabs__item is-top" :class="rotationType === 'ueber' ? 'is-active' : ''"
              @click="rotationType = 'ueber'"
            >
              Lagerübertragung
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="el-tabs__content">
      <div role="tabpanel" id="pane-Route" aria-labelledby="tab-Route" class="el-tab-pane">
        <transition name="el-fade-in-linear">
          <div v-if="rotationType === 'rotation'">
            <div class="d-flex justify-content-between">
              <h4 class="card-title">Lagerbewegung erfassen</h4>
              <div>
                <fg-input>
                  <l-checkbox v-model="scanmodus" @input="focusProduct">Scanmodus</l-checkbox>
                </fg-input>
              </div>
            </div>
            <form @submit.prevent="submit">
              <div class="form-group has-label inline-fg" style="margin-top: 1rem;">
                <label>Grund</label>
                <div class="w-100">
                  <multiselect v-model="cause"
                    :options="causes"
                    track-by="id"
                    label="name"
                    @input="causeSelected"
                    placeholder="Grund auswählen"
                  />
                  <div class="text-danger invalid-feedback" style="display: block;"
                    v-if="valErrors['cause_id']"
                  >
                    Grund muss ausgewählt werden.
                  </div>
                </div>
              </div>
              <warehouse-select
                class="form-group has-label inline-fg"
                v-if="warehouses.length > 1"
                v-model="warehouse"
                :options="warehouses"
                @input="warehouseSelected"
                :error="valErrors['warehouse_id']"
              />
              <template v-if="scanmodus">
                <div class="form-group has-label inline-fg">
                  <label>Code</label>
                  <div class="w-100">
                    <input @keydown.enter.prevent="findProduct"
                      v-model="code"
                      class="form-control" id="product"
                      :disabled="! warehouse || ! cause"
                    >
                    <div class="text-danger invalid-feedback" style="display: block;"
                      v-if="codeError"
                    >
                      {{ codeError }}
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <product-instance-select
                  class="inline-fg"
                  :value="product"
                  :options="products"
                  @input="productSelected"
                  @search="searchProducts"
                  :loading="loading"
                  :val-error="valErrors['product_instance_id'] ? valErrors['product_instance_id'][0] : ''"
                  :disabled="! warehouse || ! cause"
                />
              </template>
              <price-input
                class="inline-fg"
                :price="stockRotation.price"
                :label="cause.direction == -1 ? 'Verkaufspreis' : 'Einkaufspreis (netto)'"
                @input="stockRotation.price = $event"
                v-if="showPrice"
              />
              <div class="form-group has-label inline-fg" v-if="costCenters.length">
                <label>Kostenstelle</label>
                <multiselect v-model="costCenter"
                  :options="costCenters"
                  track-by="id"
                  label="name"
                  @input="costCenterSelected"
                  placeholder="Kostenstelle auswählen"
                />
              </div>
              <fg-input label="Kommentar">
                <textarea class="form-control" v-model="stockRotation.comment" rows="3"></textarea>
              </fg-input>
              <button type="submit" class="btn btn-fill btn-info">Erfassen</button>
            </form>
          </div>
          <div v-if="rotationType === 'ueber'">
            <div class="d-flex justify-content-between">
              <h4 class="card-title">Lagerübertragung erfassen</h4>
              <div>
                <fg-input>
                  <l-checkbox v-model="ueberScanmodus" @input="focusUeberProduct">Scanmodus</l-checkbox>
                </fg-input>
              </div>
            </div>
            <form @submit.prevent="submitUeber" style="margin-top: 0.75em;">
              <div class="row">
                <div class="col-sm-5">
                  <div class="form-group has-label">
                    <label style="
                      display: flex;
                      justify-content: space-between;
                      align-items: flex-end;
                    ">
                      <div>Von Lager</div>
                      <button class="btn btn-info btn-sm" type="button"
                        v-if="authUserWarehouse"
                        @click="setUserWarehouse('warehouseUeberFrom', warehouseUeberFromSelected)"
                      >S</button>
                    </label>
                    <multiselect v-model="warehouseUeberFrom"
                      :options="warehouses"
                      track-by="id"
                      label="short_name"
                      @input="warehouseUeberFromSelected"
                      placeholder="Lager auswählen"
                    />
                    <div class="text-danger invalid-feedback" style="display: block;"
                      v-if="valUeberErrors['warehouse_from_id']"
                    >
                      Lager muss ausgewählt werden.
                    </div>
                  </div>
                </div>
                <div class="col-sm-2 text-center" style="padding: 0px;display: flex;justify-content: center;align-items: center;">
                  <button class="btn btn-info" type="button"
                    @click="switchWarehouses"
                  >
                    <i class="fas fa-exchange-alt"></i>
                  </button>
                </div>
                <div class="col-sm-5">
                  <div class="form-group has-label">
                    <label style="
                      display: flex;
                      justify-content: space-between;
                      align-items: flex-end;
                    ">
                      <div>Nach Lager</div>
                      <button class="btn btn-info btn-sm" type="button"
                        v-if="authUserWarehouse"
                        @click="setUserWarehouse('warehouseUeberTo', warehouseUeberToSelected)"
                      >S</button>
                    </label>
                    <multiselect v-model="warehouseUeberTo"
                      :options="warehouses"
                      track-by="id"
                      label="short_name"
                      @input="warehouseUeberToSelected"
                      placeholder="Lager auswählen"
                    />
                    <div class="text-danger invalid-feedback" style="display: block;"
                      v-if="valUeberErrors['warehouse_to_id']"
                    >
                      Lager muss ausgewählt werden.
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-11">
                  <template v-if="ueberScanmodus">
                    <div class="form-group has-label">
                      <label>Code</label>
                      <input @keydown.enter.prevent="findProductUeber"
                        v-model="code"
                        class="form-control" id="product"
                      >
                      <div class="text-danger invalid-feedback" style="display: block;"
                        v-if="codeUeberError"
                      >
                        {{ codeUeberError }}
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <product-instance-select
                      :value="productUeber"
                      :options="ueberProducts"
                      @input="productUeberSelected"
                      @search="searchUeberProducts"
                      :val-error="valUeberErrors['products'] ? valUeberErrors['products'][0] : ''"
                      :loading="ueberLoading"
                    />
                  </template>
                </div>
                <div class="col-sm-1">
                  <button class="btn btn-fill btn-primary" style="margin-top: 2em;"
                    @click.prevent="addUeber" v-if="! ueberScanmodus"
                  >
                    <i class="fas fa-plus" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div class="row" v-for="adddedUeber in ueberRotations" :key="`${adddedUeber.type}_${adddedUeber.product_instance_id}`">
                <div class="col-sm-9">{{ adddedUeber.name }}</div>
                <div class="col-sm-2">{{ adddedUeber.quantity }}</div>
                <div class="col-sm-1">
                  <button class="btn btn-link btn-danger"
                    @click.prevent="deleteUeber(adddedUeber)"
                  >
                    <i class="fa fa-close"></i>
                  </button>
                </div>
              </div>
              <fg-input label="Kommentar">
                <textarea class="form-control" v-model="ueberRotation.comment" rows="3"></textarea>
              </fg-input>
              <button type="submit" class="btn btn-fill btn-info">Erfassen</button>
            </form>
          </div>
          <div v-if="rotationType === 'instance'">
            <h4 class="card-title">Produkt scannen</h4>
            <form @submit.prevent="showInstance" style="margin-top: 0.75em;">
              <div class="form-group has-label">
                <label>Code</label>
                <input v-model="infoCode"
                  class="form-control" id="info-product"
                >
                <div class="text-danger invalid-feedback" style="display: block;"
                  v-if="infoCodeError"
                >
                  Kein Produkt für diesen Barcode oder QrCode gefunden
                </div>
              </div>
            </form>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import showLabelsAlert from 'src/productInstancesLabelsAlert'
import PriceInput from 'src/components/price-input'
import ProductInstanceSelect from 'src/components/product-instance-select'
import WarehouseSelect from 'src/components/warehouse-select.vue'

export default {
  props: ['initProduct', 'initCauses'],
  components: {
    ProductInstanceSelect,
    PriceInput,
    WarehouseSelect
  },
  data () {
    return {
      rotationType: 'rotation',
      stockRotation: {
        product_instance_id: null,
        quantity: 1,
        direction: 'in',
        warehouse_id: this.$store.state.filters.warehouse ? this.$store.state.filters.warehouse.id : null,
        cause_id: null,
        cost_center_id: null,
        comment: '',
        price: ''
      },
      product: null,
      warehouse: this.$store.state.filters.warehouse || null,
      cause: null,
      costCenter: null,
      products: [],
      warehouses: [],
      causes: [],
      costCenters: [],
      valErrors: [],
      scanmodus: false,
      code: '',
      codeError: false,
      codeErrorSound: new Audio('/static/beep.wav'),
      type: 'product',
      box: null,
      ueberRotation: {
        product_instance_id: null,
        quantity: 1,
        warehouse_from_id: this.$store.state.authUser.warehouse_id,
        warehouse_to_id: null,
        comment: ''
      },
      ueberRotations: [],
      productUeber: null,
      warehouseUeberFrom: this.$store.state.authUser.warehouse || null,
      warehouseUeberTo: null,
      valUeberErrors: [],
      warehousesUeberFrom: [],
      warehousesUeberTo: [],
      authUserWarehouse: this.$store.state.authUser.warehouse || null,
      isFrontdesk: this.$store.getters.isFrontdesk,
      valInstanceErrors: [],
      productToInstanceFor: null,
      variationToInstanceFor: null,
      instanceWarehouse: this.$store.state.filters.warehouse,
      productInstance: {
        quantity: 1
      },
      ueberProducts: [],
      ueberLoading: false,
      loading: false,
      ueberScanmodus: false,
      codeUeberError: false,
      infoCode: null,
      infoCodeError: false
    }
  },
  watch: {
    initProduct (newProduct, oldProduct) {
      this.productSelected(newProduct)
      this.productUeberSelected(newProduct)
    },
    initCauses (newCauses, oldCauses) {
      // deselect cause if other direction
      if (this.cause && newCauses && newCauses.length > 0) {
        if (this.cause.direction !== newCauses[0].direction) {
          this.cause = null
          this.stockRotation.cause_id = null
        }
      }
      this.causes = newCauses
    }
  },
  computed: {
    showPrice () {
      const causeHasPrice = this.cause && this.cause.has_price
      // frontdesk must not see einkaufspreis
      if (this.isFrontdesk) {
        return causeHasPrice && this.cause.direction === -1
      }
      return causeHasPrice
    }
  },
  methods: {
    focusProduct () {
      if (this.scanmodus) {
        this.$nextTick(() => { document.getElementById('product').focus() })
      }
    },
    focusUeberProduct () {
      if (this.ueberScanmodus) {
        this.$nextTick(() => { document.getElementById('product').focus() })
      }
    },
    submit () {
      this.submitProduct()
    },
    async submitProduct () {
      await this.initCsrf()

      this.$http.post(`/stock_rotations`, this.stockRotation).then(({ data }) => {
        this.resetStockRotation()
        this.$notify({
          message: 'Die Lagerbewegung wurde erfolgreich erfasst.',
          type: 'success'
        })
        this.$emit('stockRotationsCreated', ...data.reverse())
        this.focusProduct()
        this.products = []
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    },
    async submitBox () {
      await this.initCsrf()

      this.$http.post(`/boxes/${this.box}/stock_rotations`, this.stockRotation).then(({ data }) => {
        this.resetStockRotation()
        this.$notify({
          message: 'Die Lagerbewegungen wurde erfolgreich erfasst.',
          type: 'success'
        })
        this.$emit('stockRotationsCreated', data)
        this.focusProduct()
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    },
    setStockRotationPrice (product, cause) {
      if (+cause.direction === -1) {
        this.stockRotation.price = product ? product.price : ''
      } else if (+cause.direction === 1) {
        this.stockRotation.price = product ? product.einkaufspreis : ''
      } else {
        this.stockRotation.price = ''
      }
    },
    productSelected (product) {
      this.product = product
      if (product) {
        this.type = 'product'
        this.stockRotation.product_instance_id = product ? product.instance_id : null
        if (this.cause && this.cause.has_price) {
          this.setStockRotationPrice(product, this.cause)
        } else {
          this.stockRotation.price = ''
        }
      }
    },
    warehouseSelected (warehouse) {
      this.products = []
      this.stockRotation.product_instance_id = null
      this.product = null
      this.code = null
      this.stockRotation.warehouse_id = warehouse ? warehouse.id : null
    },
    causeSelected (cause) {
      this.products = []
      this.product = null
      this.code = null
      this.stockRotation.product_instance_id = null
      this.stockRotation.cause_id = cause ? cause.id : null
      if (cause && cause.has_price && this.product) {
        this.setStockRotationPrice(this.product, cause)
      } else {
        this.stockRotation.price = ''
      }
    },
    costCenterSelected (costCenter) {
      this.stockRotation.cost_center_id = costCenter ? costCenter.id : null
    },
    resetStockRotation () {
      this.type = 'product'
      this.product = null
      this.box = null
      this.code = ''
      this.stockRotation.product_instance_id = ''
      this.stockRotation.comment = ''
      this.stockRotation.quantity = 1
      this.stockRotation.price = ''
      this.valErrors = []
    },
    findProduct (e) {
      this.codeError = false
      if (e.target.value && e.target.value.trim() && this.warehouse && this.cause) {
        let url = `/product_instances/code/${encodeURIComponent(e.target.value.trim())}`
        url += `?warehouse_id=${this.warehouse.id}`
        url += `&cause_direction=${this.cause.direction}`
        this.$http.get(url).then(({ data }) => {
          this.stockRotation.product_instance_id = data.instance_id
          if (this.cause && this.cause.has_price) {
            this.setStockRotationPrice(data, this.cause)
          }
          this.submit()
        }).catch(({ response }) => {
          this.codeError = response.data.message
          this.codeErrorSound.play()
        })
      }
    },
    showInstance () {
      this.infoCodeError = false

      this.$http.get(`/product_instances/code/${encodeURIComponent(this.infoCode)}`).then(({ data }) => {
        this.$router.push(`/product_instances/${data.instance_id}`)
      }).catch(({ response }) => {
        this.infoCodeError = true
        this.codeErrorSound.play()
      })
    },
    productUeberSelected (product) {
      this.productUeber = product
      if (product) {
        this.ueberRotation.product_instance_id = product ? product.instance_id : null
      }
    },
    warehouseUeberFromSelected (warehouse) {
      this.ueberRotation.warehouse_from_id = warehouse ? warehouse.id : null
      this.ueberProducts = []
      this.productUeber = null
      // if (warehouse) {
      //   this.warehousesUeberTo = this.warehouses.filter(wh => warehouse.id !== wh.id)
      // } else {
      //   this.warehousesUeberTo = []
      //   this.ueberRotation.warehouse_to_id = null
      //   this.warehouseUeberTo = null
      // }
    },
    warehouseUeberToSelected (warehouse) {
      this.ueberRotation.warehouse_to_id = warehouse ? warehouse.id : null
    },
    async submitUeber () {
      this.addUeber()

      await this.initCsrf()
      this.$http.post(`/stock_rotations/ueber`, {
        warehouse_from_id: this.ueberRotation.warehouse_from_id,
        warehouse_to_id: this.ueberRotation.warehouse_to_id,
        products: this.ueberRotations,
        comment: this.ueberRotation.comment
      }).then(({ data }) => {
        this.productUeber = null
        this.ueberRotation.product_instance_id = ''
        this.ueberRotation.comment = ''
        this.ueberRotation.quantity = 1
        this.ueberRotations = []
        this.valErrors = []
        this.$notify({
          message: 'Die Lagerübertragungen wurden erfolgreich erfasst.',
          type: 'success'
        })
        this.$emit('stockRotationsCreated', ...data.reverse())
      }).catch(({ response }) => { this.valUeberErrors = response.data.errors })
    },
    addUeber () {
      if (this.productUeber && this.ueberRotation.quantity) {
        const index = this.getUeberProduct(this.ueberRotation.product_instance_id)
        if (index >= 0) {
          // do nothing bec quantity only 1
          // this.ueberRotations[index].quantity += this.ueberRotation.quantity
        } else {
          this.ueberRotations.push({
            name: this.getUeberName(this.productUeber),
            product_instance_id: this.ueberRotation.product_instance_id,
            quantity: this.ueberRotation.quantity
          })
        }
        this.productUeber = null
        this.ueberRotation.product_instance_id = ''
        this.ueberRotation.quantity = 1
        this.ueberProducts = []
      }
    },
    deleteUeber (ueber) {
      this.ueberRotations.splice(this.getUeberProduct(ueber.product_instance_id), 1)
    },
    getUeberProduct (id) {
      return this.ueberRotations.findIndex(rot => rot.product_instance_id === id)
    },
    setUserWarehouse (warehouseToSet, warehouseSelected) {
      this[warehouseToSet] = this.authUserWarehouse
      warehouseSelected(this.authUserWarehouse)
    },
    switchWarehouses () {
      const from = this.warehouseUeberFrom
      const to = this.warehouseUeberTo
      this.warehouseUeberFrom = to
      this.warehouseUeberFromSelected(to)
      this.warehouseUeberTo = from
      this.warehouseUeberToSelected(from)
    },
    async submitInstance () {
      await this.initCsrf()

      const url = `/products/${this.variationToInstanceFor.id}/instances`
      this.$http.post(url, {
        qty: this.productInstance.quantity,
        warehouse_id: this.instanceWarehouse ? this.instanceWarehouse.id : ''
      }).then(({ data }) => {
        this.$notify({
          message: 'Die Instanzierung wurden erfolgreich erfasst.',
          type: 'success'
        })
        this.$emit('instancesCreated')
        showLabelsAlert(data)
      })
    },
    searchUeberProducts (query) {
      this.ueberLoading = true
      let url = `/product_instances?search=${encodeURIComponent(query)}`
      if (this.warehouseUeberFrom) {
        url += `&warehouse_id=${this.warehouseUeberFrom.id}`
      }
      this.$http.get(url).then(({ data }) => {
        this.ueberProducts = data
        this.ueberLoading = false
      })
    },
    searchProducts (query) {
      this.loading = true
      let url = `/product_instances?search=${encodeURIComponent(query)}`
      url += `&warehouse_id=${this.warehouse.id}`
      url += `&cause_direction=${this.cause.direction}`
      this.$http.get(url).then(({ data }) => {
        this.products = data
        this.loading = false
      })
    },
    findProductUeber (e) {
      this.codeUeberError = false

      let url = `/product_instances/code/${encodeURIComponent(e.target.value)}`

      if (this.warehouseUeberFrom) {
        url += `?warehouse_id=${this.warehouseUeberFrom.id}`
      }

      this.$http.get(url).then(({ data }) => {
        this.productUeber = data
        this.ueberRotation.product_instance_id = data.instance_id
        this.submitUeber()
      }).catch(({ response }) => {
        this.codeUeberError = response.data.message
        this.codeErrorSound.play()
      })
    },
    getUeberName (product) {
      let label = `#${product.instance_id}: ${product.name}`
      const features = product.stringRepShort.join(' | ')
      return label + (features ? ` (${features})` : '')
    }
  },
  created () {
    if (!this.initCauses) {
      this.$http.get(`/causes?only_selectable=1`).then(({ data }) => {
        this.causes = data
      })
    }
    this.$http.get(`/cost_centers`).then(({ data }) => {
      this.costCenters = data
    })
    this.$http.get(`/warehouses`).then(({ data }) => {
      this.warehouses = data
    })
  }
}
</script>

<style>
</style>
